import { render, staticRenderFns } from "./ListPortray.vue?vue&type=template&id=22dd39fc&scoped=true"
import script from "./ListPortray.vue?vue&type=script&lang=js"
export * from "./ListPortray.vue?vue&type=script&lang=js"
import style0 from "./ListPortray.vue?vue&type=style&index=0&id=22dd39fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd39fc",
  null
  
)

export default component.exports